module.exports = __webpack_public_path__ + "static/media/1.5 Barbara nach.cbb1327a.JPG";